export default "__VITE_ASSET__IDeFHSef__"